/*
 * "Sélecteur durée + Pack" — synchronise l'état visuel (carte sélectionnée,
 * prix du Pack affiché) avec l'état réel des radios natifs du variant picker.
 * La sélection elle-même est gérée nativement par <label for="..."> pointant
 * vers ces mêmes radios : aucune logique de variante n'est dupliquée ici.
 */
(function () {
  'use strict';

  function initSelector(root) {
    if (!root || root.dataset.pdsBound === '1') return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-duration-card]'));
    var packPrices = Array.prototype.slice.call(root.querySelectorAll('[data-pack-price]'));
    if (!cards.length) return;

    function sync() {
      cards.forEach(function (card) {
        var radio = document.getElementById(card.getAttribute('data-target-radio-id'));
        var isChecked = !!(radio && radio.checked);
        card.classList.toggle('is-selected', isChecked);
        if (isChecked) {
          var idx = card.getAttribute('data-duration-card');
          packPrices.forEach(function (priceEl) {
            priceEl.hidden = priceEl.getAttribute('data-pack-price') !== idx;
          });
        }
      });
    }

    function bindRadioListeners() {
      cards.forEach(function (card) {
        var radio = document.getElementById(card.getAttribute('data-target-radio-id'));
        if (radio) radio.addEventListener('change', sync);
      });
    }

    bindRadioListeners();

    // Le variant picker natif peut remplacer entièrement ses radios (rafraîchi
    // via fetch) après un changement, ce qui rend les listeners ci-dessus
    // orphelins. On ré-attache + resynchronise sur l'événement natif stable
    // (émis sur document, jamais détruit) quand la section est connue.
    var sectionId = root.getAttribute('data-section-id');
    if (sectionId) {
      document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function () {
        bindRadioListeners();
        sync();
      });
    }

    sync();
    root.dataset.pdsBound = '1';
  }

  function boot() {
    document.querySelectorAll('[data-duration-selector]').forEach(initSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-duration-selector]')
      : null;
    if (root) initSelector(root);
  });
})();
